<div class="user-top pt-2">
  <p class="text-white  ps-4"> Selamat Datang, <span class="fst-italic fw-bold">{{FirmNameView}} | {{NameView}} | {{RoleView}}</span>
  </p>
</div>
